function saveToLocalStorage(key: string, value: string): void {
  localStorage.setItem(key, value);
}

function saveObjectToLocalStorage<T>(key: string, value: T): void {
  localStorage.setItem(key, JSON.stringify(value));
}

function getFromLocalStorage(key: string): any {
  return localStorage.getItem(key);
}

function getObjectFromLocalStorage<T>(key: string): T {
  const item = localStorage.getItem(key);
  return item && JSON.parse(item);
}

function removeLocalStorage(key: string): any {
  localStorage.removeItem(key);
}

export {
  saveToLocalStorage,
  saveObjectToLocalStorage,
  getFromLocalStorage,
  getObjectFromLocalStorage,
  removeLocalStorage,
};
